import { render, staticRenderFns } from "./index.vue?vue&type=template&id=729c4fff"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729c4fff')) {
      api.createRecord('729c4fff', component.options)
    } else {
      api.reload('729c4fff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=729c4fff", function () {
      api.rerender('729c4fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/inbound/index.vue"
export default component.exports